import {post} from '../script/serviceApiPost';

export default{
  async save(requestParam: any) {
    const result = await post('fun/save', requestParam);
    return result;
  },
  async removeByIds(requestParam: any) {
    const result = await post('fun/removeByIds', requestParam);
    return result;
  },
  async updateById(requestParam: any) {
    const result = await post('fun/updateById', requestParam);
    return result;
  },
  async getById(requestParam: any) {
    const result = await post('fun/getById', requestParam);
    return result;
  },
  async selectPageData(requestParam: any) {
    const result = await post('fun/selectPageData', requestParam);
    return result;
  },
  async count(requestParam: any) {
    const result = await post('fun/count', requestParam);
    return result;
  },
  
 
};
